export default __webpack_public_path__ + "static/media/Ellipse-44.793e4e45.svg";